/* tslint:disable */

import { defineMessages } from 'react-intl';

export default defineMessages({
    summaries: {
        defaultMessage: 'Summaries',
        id: 'component.Categorizer.summaries',
    },
    selectAll: {
        defaultMessage: 'All events',
        id: 'component.CategorizerSubmenuHeader.selectAll',
    },
});
